import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core'

@Directive({
  selector: '[longPress]',
})
export class LongPressDirective implements OnDestroy {
  @Input() duration: number = 500 // Default long press duration in milliseconds
  @Output() onLongPress = new EventEmitter<Event>()
  @Output() onLongPressEnd = new EventEmitter<Event>()
  @Output() onClick = new EventEmitter<Event>()

  private timeoutId: any
  private isLongPress = false

  constructor() {}

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onPressStart(event: Event): void {
    event.preventDefault() // Prevent default to avoid undesired behavior
    this.isLongPress = false
    this.timeoutId = setTimeout(() => {
      this.isLongPress = true
      this.onLongPress.emit(event)
    }, this.duration)
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('mouseleave')
  @HostListener('touchend', ['$event'])
  @HostListener('touchcancel')
  onPressEnd(event: Event): void {
    clearTimeout(this.timeoutId)
    if (!this.isLongPress) {
      this.onClick.emit(event)
    } else {
      this.onLongPressEnd.emit(event)
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId)
  }
}
